module.exports = __webpack_public_path__ + "img/k1.6ea718cb.png";